/**
 * Ponte para o agendador de terceiros declarado no `index.html`.
 *
 * POR QUE O AGENDADOR VIVE NO INDEX E NÃO AQUI: ele precisa existir antes do
 * bundle, porque os próprios blocos do index (Pixel, OneSignal, AdSense) o usam.
 * Ter DUAS implementações do gatilho é que seria o erro — então aqui não há
 * lógica de listener nenhuma, só a chamada.
 *
 * POR QUE O GATILHO É GESTO E NÃO TEMPO (medido em 06/08/2026, /viaroma em prod):
 * a janela que conta para o TBT vai do FCP (1,2s) ao TTI (20,2s sob a rede
 * simulada do Lighthouse). O gatilho antigo, `load + 3s`, disparava em ~4,5s —
 * dentro da janela. Diferir por tempo não tira o custo do orçamento; só sai o que
 * não carrega ou o que carrega depois de um gesto.
 */

type Agendador = (fn: () => void) => void;

/**
 * Executa `fn` no primeiro gesto do usuário (ou quando a aba é escondida/fechada).
 *
 * Sem o agendador — SSR, testes unitários, ou um `index.html` antigo ainda em
 * cache no browser do cliente — executa NA HORA. O fallback é deliberado: perder
 * performance é aceitável, deixar de carregar analytics ou o SDK de push não é.
 */
export function aposPrimeiroGesto(fn: () => void): void {
	const agendador: Agendador | undefined =
		typeof window !== 'undefined' ? (window as any).mpAposGesto : undefined;

	if (typeof agendador === 'function') {
		agendador(fn);
		return;
	}

	fn();
}
